import { TOrderSettings } from '../types/orderConfiguration';

export const defaultOrderSettings: TOrderSettings = {
  isCheckout: 0,
  isFranchise: 0,
  isCrossSelling: 0,
  config: {
    vat: '',
    vatIncluded: 0,
    taxableDeliveryFee: 0,
    vatRegistrationNumber: '',
    certificateUrl: '',
    certificateFilename: '',
    certificate: new File([], ''),
  },
  notes: {
    smsEditOrder: 0,
    allowNotesAtCheckout: 0,
    allowItemNotes: 0,
    allowOrderForElse: 0,
    upsalesFrequency: 0,
    is_cc_zone_orders: 0,
  },
};
